

export const Team = () => {

    return (

        <>
            <div className="team">
      <p>Experienced</p>
      <h2>Meet Our Team</h2>
      <p>
        Our professional team of writers, editors, and customer service
        representatives.
      </p>
    </div>
    <div className="row">
      <div className="col-lg-3">
        <div className="cards">
          <div className="card mt-3">
            <img
              className="card-img-top"
              src="/images/man-3209233_640.jpg"
              alt="Card image cap"
              height="150px"
            />
            <div className="card-body">
              <h5 className="card-title">John Doe</h5>
              <h5 className="card-title">Writer</h5>
              <p className="card-text">
                John is skilled in various writing capacities with numerous
                academic qualifications.
              </p>
              <a href="#" className="btn">
                <i className="fa-brands fa-linkedin" />
              </a>
              <a href="#" className="btn">
                <i className="fa-brands fa-facebook" />
              </a>
              <a href="#" className="btn">
                <i className="fa-brands fa-square-x-twitter" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-3">
        <div className="cards">
          <div className="card mt-3">
            <img
              className="card-img-top"
              src="/images/man-3209233_640.jpg"
              alt="Card image cap"
              height="150px"
            />
            <div className="card-body">
              <h5 className="card-title">Jane Smith</h5>
              <h5 className="card-title">Editor</h5>
              <p className="card-text">
                Jane ensures the company documents meet the highest standards.
              </p>
              <a href="#" className="btn">
                <i className="fa-brands fa-linkedin" />
              </a>
              <a href="#" className="btn">
                <i className="fa-brands fa-facebook" />
              </a>
              <a href="#" className="btn">
                <i className="fa-brands fa-square-x-twitter" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-3">
        <div className="cards">
          <div className="card mt-3">
            <img
              className="card-img-top"
              src="/images/man-3209233_640.jpg"
              alt="Card image cap"
              height="150px"
            />
            <div className="card-body">
              <h5 className="card-title">David Johnson</h5>
              <h5 className="card-title">Customer Representative</h5>
              <p className="card-text">
                David is dedicated to providing excellent customer support and
                achieving client satisfaction.
              </p>
              <a href="#" className="btn">
                <i className="fa-brands fa-linkedin" />
              </a>
              <a href="#" className="btn">
                <i className="fa-brands fa-facebook" />
              </a>
              <a href="#" className="btn">
                <i className="fa-brands fa-square-x-twitter" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-3">
        <div className="cards">
          <div className="card mt-3">
            <img
              className="card-img-top"
              src="/images/man-3209233_640.jpg"
              alt="Card image cap"
              height="150px"
            />
            <div className="card-body">
              <h5 className="card-title">Emily Wilson</h5>
              <h5 className="card-title">Writer</h5>
              <p className="card-text">
                Emily has a passion for research and crafting written customer
                responses.
              </p>
              <a href="#" className="btn">
                <i className="fa-brands fa-linkedin" />
              </a>
              <a href="#" className="btn">
                <i className="fa-brands fa-facebook" />
              </a>
              <a href="#" className="btn">
                <i className="fa-brands fa-square-x-twitter" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
        </>
    )
}